class TransferFrequencyTypes {
  static MONTHLY = 'MONTHLY';
  static DAILY = 'DAILY';
  static ANNUALLY = 'ANNUALLY';

  static getStr(en) {
    switch (en) {
      case TransferFrequencyTypes.MONTHLY:
        return 'Bulanan';
      case TransferFrequencyTypes.DAILY:
        return 'Harian';
      case TransferFrequencyTypes.ANNUALLY:
        return 'Tahunan';
      default:
        return 'Unknown';
    }
  }
}

const TransferFrequencyOpts = [
  { value: TransferFrequencyTypes.MONTHLY, label: TransferFrequencyTypes.getStr(TransferFrequencyTypes.MONTHLY) },
  { value: TransferFrequencyTypes.DAILY, label: TransferFrequencyTypes.getStr(TransferFrequencyTypes.DAILY) },
  { value: TransferFrequencyTypes.ANNUALLY, label: TransferFrequencyTypes.getStr(TransferFrequencyTypes.ANNUALLY) }
];

export { TransferFrequencyTypes, TransferFrequencyOpts };
